function PriceCheck({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M6.18766 13.5067V12.5901H3.896V11.2151H8.47933V8.9234H4.70688C4.47713 8.9234 4.28455 8.84569 4.12913 8.69027C3.97371 8.53485 3.896 8.34226 3.896 8.11252V4.69266C3.896 4.4629 3.97371 4.27031 4.12913 4.11489C4.28455 3.95946 4.47713 3.88175 4.70688 3.88175H6.18766V2.96509H7.56262V3.88175H9.85428V5.25673H5.27095V7.54842H9.0434C9.27315 7.54842 9.46573 7.62613 9.62115 7.78155C9.77657 7.93697 9.85428 8.12957 9.85428 8.35933V11.7792C9.85428 12.0089 9.77657 12.2015 9.62115 12.3569C9.46573 12.5124 9.27315 12.5901 9.0434 12.5901H7.56262V13.5067H6.18766ZM12.7876 18.9186L9.20913 15.3401L10.1751 14.3741L12.7876 16.9866L17.9844 11.7898L18.9504 12.7558L12.7876 18.9186Z" />
    </svg>
  );
}

export default PriceCheck;
